import DeliveryMethodCard from './DeliveryMethodCard';

export default DeliveryMethodCard;
